import Ubuntu from "./components/ubuntu";

import "./styles/main.css";

function UbuntuApp() {
  return <Ubuntu />;
}

export default UbuntuApp;
